import { StateCreator } from "zustand";
import { NavigationState, SegmentsSliceState, Segments } from "../types";
import { isRealTab } from "../helpers";

const MAX_HISTORY_SIZE = 10;

export const createSegmentsSlice: StateCreator<
  NavigationState,
  [],
  [],
  SegmentsSliceState
> = (set) => ({
  segments: ["(app)"],
  segmentsHistory: [["(app)"]],
  tab: "explore",

  onSegmentsChange: (segments: Segments) =>
    set((state) => {
      // Update history by adding current segments, keeping only last MAX_HISTORY_SIZE entries
      const newHistory = [...state.segmentsHistory, state.segments].slice(
        -MAX_HISTORY_SIZE,
      );

      const tabIndex = segments.findIndex((segment) => segment === "(tabs)");
      if (tabIndex === -1) {
        return { segments, segmentsHistory: newHistory };
      }
      const tab = segments[tabIndex + 1];
      if (tab && isRealTab(tab)) {
        return {
          segments,
          segmentsHistory: newHistory,
          tab,
        };
      }
      return { segments, segmentsHistory: newHistory };
    }),
});
